import {MovilDTO} from "../movil.dto";
import {BaseResponseDTO} from "./base.response.dto";


export class GetListaMovilesResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: {
      hasNext: boolean;
      hasPrev: boolean;
      pageIndex: number;
      pageSize: number;
      totalPageCount: number;
      totalRowCount: number;
      list: Array<MovilDTO>;
    }
  
  }
  